import { WelcomeShell } from '../components/composite/welcome/welcome_shell/WelcomeShell';
import type { ScreenViewProps } from '../shared/screenViewProps';
import { Button } from './button/Button';
import { Character } from './character/Character';
import { Texts } from './texts/Texts';
import type { WelcomeDelivery1Controller } from './WelcomeDelivery1Controller';
import type { WelcomeDelivery1ScreenModel } from './WelcomeDelivery1ModelScreen';
import './welcome_delivery_1.css';

export type WelcomeDelivery1ViewProps = ScreenViewProps<
  WelcomeDelivery1ScreenModel,
  WelcomeDelivery1Controller
>;

export function WelcomeDelivery1View({
  controller,
}: WelcomeDelivery1ViewProps) {
  return (
    <WelcomeShell
      className="welcome-delivery-1"
      paginatorCurrent={1}
      beforeDialog={<Character />}
      afterDialog={<Texts />}
      button={<Button onClick={controller.handleContinue} />}
    />
  );
}
